module.exports = __webpack_public_path__ + "static/ESITCMetz-d924f140046ecc63e1280b6c10680062.png";